export default [
  {path: '/copymedical', component: () => import('../page/copymedical/index')},
]



// WEBPACK FOOTER //
// ./src/router/copymedical.js